module.exports = __webpack_public_path__ + "static/media/vouchers-setup.4796ce0c.png";